/**
 * @fileoverview Shared dropdown option lists for the sales feature's forms and filters.
 * @description Static reference data (states, bank types, lead sources) — not fetched from an
 * endpoint, same as the bundle design's own hardcoded `<option>` lists, since these are
 * enumerated domain values rather than business data.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

export const STATE_OPTIONS = [
  'Maharashtra',
  'Gujarat',
  'Karnataka',
  'Telangana',
  'Tamil Nadu',
  'Uttar Pradesh',
]

/** Sales Pipeline's "Creation Rules": "Bank Type contains only the three agreed co-operative bank
 * categories" — the only bank-type list the Tenant model (and every page built on it) uses. */
export const TENANT_BANK_TYPE_OPTIONS = [
  'Urban Co-operative',
  'State Co-operative',
  'District Central Co-operative',
] as const

export const CORE_BANKING_OPTIONS = ['Finacle', 'TCS BaNCS', 'Flexcube', 'In-house', 'Other']

export const LEAD_SOURCE_OPTIONS = [
  'Referral',
  'Inbound Enquiry',
  'Cold Call',
  'Industry Event',
  'Partner',
]

export const LEAD_RATING_OPTIONS = ['Hot', 'Warm', 'Cold'] as const

export const TEAM_ROLE_OPTIONS = ['Sales Head', 'Sales Manager', 'Sales Executive'] as const

export const PRIORITY_OPTIONS = ['High', 'Medium', 'Low'] as const
